import decimalAdjust from './internals/decimalAdjust.js';

function round(number, precision) {
    return decimalAdjust('round', number, precision);
}

export { round as default };
